import { render } from "./ButtonCircle.vue?vue&type=template&id=a44310a4"
import script from "./ButtonCircle.vue?vue&type=script&lang=js"
export * from "./ButtonCircle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__